module.exports = __webpack_public_path__ + "static/img/fuel_256.e2340ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fuel_256.png
// module id = Ghv5
// module chunks = 0